<div (click)="clickEvent.emit()" class="card cursor-pointer border mediaContainer" [ngClass]="divNgClass">
  <div class="card-content">
    <div class="card-img-top position-relative" *ngIf="medium?.id">
      <sb-comp-medium [medium]="medium" [customHeight]="110+'px'" [customWidth]="100+'%'" [thumbnailSize]="'M'"
                      [still]="true" (click)="clickEvent.emit()"></sb-comp-medium>
      <div class="position-absolute" style="bottom: 9px;left: 5px;" *ngIf="!medium.processing">
        <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [editable]="false" [tags]="medium.tags"
                 [dtoType]="tagService.TaggableDTO.Medium" [dtoId]="medium.id"></sb-tags>
      </div>
    </div>
    <div class="card-fit p-2">
      <div class="tw-flex tw-gap-4">
        <button (dragend)="dragendEmitter.emit()" (dragstart)="dragstartEmitter.emit({event: $event, item: medium})"
                [draggable]="medium?.id" class="btn btn-hover-primary">
          <sb-icon icon="drag"></sb-icon>
        </button>
        @if (isInFolderContext) {
          <div>
            <div>{{ 'lang.headlines.folder' |translate }}:</div>
            <div>{{ medium?.folder?.name ?? '-' }}</div>
          </div>
        }
        <ng-container *ngIf="multiSelect">
          <button class="btn btn-hover-primary ml-1 mr-1" (click)="$event.stopPropagation(); $event.preventDefault(); selectEmitter.emit()"
                  [ngClass]="{'btn-hover-primary--active' : isSelected}">
            <sb-icon *ngIf="isSelected" icon="boxChecked"></sb-icon>
            <sb-icon *ngIf="!isSelected" icon="box"></sb-icon>
          </button>
        </ng-container>
      </div>
      <div class="mb-4">
        <ng-container *ngIf="!medium.uploading && !medium.processing">
          <small *ngIf="!medium?.locked && medium.usageCount === 0" class="red">
            <sb-icon icon="lockOpen"></sb-icon>&nbsp;&nbsp;{{ 'lang.mediumExplorer.notReadyUse' | translate }}
          </small>
          <small *ngIf="medium?.locked && medium.usageCount === 0" class="yellow">
            <sb-icon icon="lockClosed"></sb-icon>&nbsp;&nbsp;{{ 'lang.mediumExplorer.readyUse' | translate }}
          </small>
          <small *ngIf="medium?.locked && medium.usageCount >= 1" class="green">
            <sb-icon icon="lockClosed"></sb-icon>&nbsp;&nbsp;{{ 'lang.mediumExplorer.inUse' | translate }}
          </small>
        </ng-container>
        <h5 [innerHTML]="(medium?.name ?? 'unknown file name') | truncate : 17"></h5>
        <div class="row">
          <div class="col-6">
            <sb-icon class="mr-1" icon="company"></sb-icon>
            <span
              [innerHTML]="(medium?.company?.name ?? 'unknown company') | truncate : 8"></span>
          </div>
          <div class="col-6">
            <span style="white-space: nowrap;" [ngbTooltip]="all" container="body">
              <sb-icon class="mr-1" icon="product"></sb-icon>
              @if (medium?.promotedProducts?.length >= 1) {
                @if (medium?.promotedProducts?.length === 1) {
                  <span [innerHTML]="medium?.promotedProducts[0]?.name |truncate:8"></span>
                } @else {
                  <span [innerHTML]="medium?.promotedProducts?.length +' '+ ('lang.globals.products' | translate) | truncate : 8"></span>
                }
              } @else {
                <i>-</i>
              }
            </span>
          </div>
          <ng-template #all>
            <table class="table table-borderless">
              @for (element of medium?.promotedProducts; track element.id) {
                <tr>
                  <td class="text-start" [innerHTML]="element?.name | truncate : 25"></td>
                </tr>
              } @empty {
                <tr>
                  <td class="text-start" [innerHTML]="('lang.globals.noProducts' | translate)"></td>
                </tr>
              }
            </table>
          </ng-template>
        </div>
      </div>
      <div *ngIf="!medium.uploading && !medium.processing" class="row">
        <div class="col-6" [class.red]="displayNoMatching" container="body"
             [ngbTooltip]="displayNoMatching? ('lang.globals.noMatchingResolution' | translate) : null">
          <sb-icon icon="marker"></sb-icon>
          {{ medium?.resolution?.id }}
          <sb-icon icon="attention" class="red" *ngIf="displayNoMatching"></sb-icon>
        </div>
        <div class="col-6">
          <sb-icon icon="clock"></sb-icon>
          {{ medium?.duration ? medium?.duration + 's' : '-' }}
        </div>
        <div class="col-6">
          <sb-icon class="mr-1" icon="motives"></sb-icon>
          <span [innerHTML]="medium?.mediumGroup?.name ?? '-' | truncate : 12"></span>
        </div>
        <div class="col-6">
          <sb-icon class="mr-1" icon="templates"></sb-icon>
          <span [innerHTML]="medium?.templateGroup?.name ?? '-' | truncate : 12"></span>
        </div>
        <div class="col-6" *ngIf="medium?.contentType" [ngSwitch]="true">
          <sb-icon *ngSwitchCase="medium?.contentType.indexOf('video') !== -1" icon="video"></sb-icon>
          <sb-icon *ngSwitchCase="medium?.contentType.indexOf('image') !== -1" icon="photo"></sb-icon>
          <sb-icon *ngSwitchDefault icon="brackets"></sb-icon>
          <span class="ml-1" [innerHTML]="medium?.contentType | truncate : 12"></span>
        </div>
        <div class="col-6">
          <sb-icon icon="file"></sb-icon>
          {{ util.formatBytes(medium?.size) }}
        </div>
        <div class="col-6">
          <sb-icon icon="clock"></sb-icon>
          {{ medium?.createdAt?.toString() ?? '-' | date: 'dd.MM.yy' }}
        </div>
        <div class="col-6">
          <sb-icon icon="user"></sb-icon>
          {{ medium?.createdBy?.name ?? '-' }}
        </div>
      </div>
    </div>
  </div>
</div>
